export const codeRegex = /^\d{4}$/
export const phoneKzRegex = /^\+7\s\([67]\d{2}\)\s\d{3}-\d{2}-\d{2}$/

